import { APP_URL, CONTACT_EMAIL, H2, LegalLayout, P, Table } from './shared';

// Public, unauthenticated route (see App.tsx) - same content as
// landing/templates.mjs's renderCookiePolicy(), ported to this app's
// components. "Cookie settings" reopens CookieConsentBanner (see
// components/CookieConsentBanner.tsx) instead of a footer link, since this
// app doesn't have a persistent footer - the Settings screen has the row.
export function CookiePolicyScreen() {
  return (
    <LegalLayout title="Cookie Policy">
      <P>
        This page explains what zmist stores in your browser and why. You can change your choices at any time from
        the "Cookie settings" row in Settings.
      </P>

      <H2>What we actually use today</H2>
      <P>
        Honestly: almost nothing. The zmist web app ({APP_URL}) keeps you signed in using <strong>browser local
        storage</strong>, not a tracking cookie - it holds your session token and a couple of display preferences,
        is never sent to any third party, and is cleared when you log out. This app also sets one local-storage
        entry of its own: the choice you make in the cookie banner, so we don't ask you again every visit.
      </P>
      <P>
        We currently set <strong>no analytics cookies and no marketing/advertising cookies</strong>. If that ever
        changes, this page and the cookie-preferences banner's categories will be updated to match before anything
        new is turned on - not after.
      </P>

      <H2>The categories the cookie banner offers</H2>
      <Table>
        <thead>
          <tr className="text-left text-black/40 dark:text-white/40 text-[12px] uppercase tracking-wide">
            <th className="py-2 pr-4 font-medium">Category</th>
            <th className="py-2 pr-4 font-medium">Status</th>
            <th className="py-2 font-medium">What it's for</th>
          </tr>
        </thead>
        <tbody className="align-top">
          <tr className="border-t border-black/10 dark:border-white/10">
            <td className="py-2.5 pr-4 whitespace-nowrap">Essential</td>
            <td className="py-2.5 pr-4 whitespace-nowrap text-black/50 dark:text-white/50">Always on</td>
            <td className="py-2.5 text-black/70 dark:text-white/70">
              Sign-in state and your saved preferences (local storage, not a cookie in the strict sense - see
              above). The Service doesn't function without this.
            </td>
          </tr>
          <tr className="border-t border-black/10 dark:border-white/10">
            <td className="py-2.5 pr-4 whitespace-nowrap">Analytics</td>
            <td className="py-2.5 pr-4 whitespace-nowrap text-black/50 dark:text-white/50">Off, opt-in only</td>
            <td className="py-2.5 text-black/70 dark:text-white/70">Would help us understand usage in aggregate, if we ever enable it.</td>
          </tr>
          <tr className="border-t border-black/10 dark:border-white/10">
            <td className="py-2.5 pr-4 whitespace-nowrap">Marketing</td>
            <td className="py-2.5 pr-4 whitespace-nowrap text-black/50 dark:text-white/50">Off, opt-in only</td>
            <td className="py-2.5 text-black/70 dark:text-white/70">Would support measuring zmist's own advertising, if we ever run any.</td>
          </tr>
        </tbody>
      </Table>

      <H2>Changing your choice</H2>
      <P>Open Settings and tap "Cookie settings" at any time to reopen the banner and change what you've allowed.</P>

      <H2>Browser controls</H2>
      <P>You can also clear local storage/cookies for this site directly through your browser's own settings - doing so signs you out and resets any saved preference here.</P>

      <H2>Questions</H2>
      <P>{CONTACT_EMAIL}</P>
    </LegalLayout>
  );
}
